/**
 * 主题管理器
 * 支持亮色/暗色主题切换
 */

export type Theme = 'light' | 'dark'

const THEME_KEY = 'app-theme'

/**
 * 获取当前主题
 */
function getTheme(): Theme {
  const savedTheme = localStorage.getItem(THEME_KEY) as Theme | null
  if (savedTheme && (savedTheme === 'light' || savedTheme === 'dark')) {
    return savedTheme
  }
  // 默认跟随系统主题
  if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return 'dark'
  }
  return 'light'
}

/**
 * 设置主题
 */
function setTheme(theme: Theme): void {
  const html = document.documentElement
  if (theme === 'dark') {
    html.classList.add('dark')
    html.setAttribute('data-theme', 'dark')
  } else {
    html.classList.remove('dark')
    html.setAttribute('data-theme', 'light')
  }
  localStorage.setItem(THEME_KEY, theme)
}

/**
 * 切换主题
 */
function toggleTheme(): Theme {
  const currentTheme = getTheme()
  const newTheme: Theme = currentTheme === 'dark' ? 'light' : 'dark'
  setTheme(newTheme)
  return newTheme
}

/**
 * 判断当前是否为暗色主题
 */
function isDark(): boolean {
  return getTheme() === 'dark'
}

const themeManager = {
  getTheme,
  setTheme,
  toggleTheme,
  isDark
}

export default themeManager
